export interface FormData {
  // Step 1: Business Information
  business_name: string;
  business_type: string;
  business_address: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  
  // Step 2: Business Details
  establishment_size: string;
  business_description: string;
  target_demographics: string;
  current_marketing_channels: string[];
  website_url: string;
  social_media_urls: {
    facebook?: string;
    instagram?: string;
    linkedin?: string;
  };
  
  // Step 3: Partnership Interest
  desired_offer_types: string[];
  expected_customer_volume: string;
  marketing_goals: string;
  
  // Step 4: Documentation
  business_license_number: string;
  tax_id: string;
  vat_number: string;
  applicant_notes: string;
}

export interface FormErrors {
  [key: string]: string;
}

export interface StepConfig {
  id: number;
  title: string;
  description: string;
  fields: string[];
}

export const BUSINESS_TYPES = [
  'Restaurant',
  'Café & Bar',
  'Hotel & Accommodation',
  'Museum & Gallery',
  'Theater & Entertainment',
  'Shopping & Retail',
  'Sports & Fitness',
  'Beauty & Wellness',
  'Transportation',
  'Services',
  'Other',
];

export const ESTABLISHMENT_SIZES = [
  'Small (1-10 employees)',
  'Medium (11-50 employees)',
  'Large (51-200 employees)',
  'Enterprise (200+ employees)',
];

export const MARKETING_CHANNELS = [
  'Social Media',
  'Email Marketing',
  'Print Advertising',
  'Online Advertising',
  'Word of Mouth',
  'Events & Sponsorships',
  'SEO & Website',
  'Influencer Marketing',
  'Traditional Media',
  'None Currently',
];

export const OFFER_TYPES = [
  'Percentage Discount',
  '2-for-1 Deals',
  'Free Items/Services',
  'Package Deals',
  'Early Access',
  'Exclusive Experiences',
  'Seasonal Promotions',
  'Loyalty Rewards',
];

export const CUSTOMER_VOLUMES = [
  'Less than 100/month',
  '100-500/month',
  '500-1,000/month',
  '1,000-5,000/month',
  '5,000-10,000/month',
  'More than 10,000/month',
];